webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(312),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-160f9195",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./01-globus.gif": 91,
	"./06-huette.jpg": 92,
	"./0754.jpg": 93,
	"./0755.jpg": 94,
	"./0756.jpg": 95,
	"./0757.jpg": 96,
	"./0758.jpg": 97,
	"./0759.jpg": 98,
	"./0760.jpg": 99,
	"./0761.jpg": 100,
	"./0762.jpg": 101,
	"./0763.jpg": 102,
	"./0764.jpg": 103,
	"./0765.jpg": 104,
	"./0767.jpg": 105,
	"./0768.jpg": 106,
	"./0769.jpg": 107,
	"./0770.jpg": 108,
	"./0771.jpg": 109,
	"./0772.jpg": 110,
	"./0773.jpg": 111,
	"./0774.jpg": 112,
	"./0775.jpg": 113,
	"./0776.jpg": 114,
	"./08-lampe.jpg": 115,
	"./30er-lampe.png": 116,
	"./Bachelor_010157.jpg": 117,
	"./Bachelor_010159.jpg": 118,
	"./Bachelor_010177.jpg": 119,
	"./Bachelor_010193.jpg": 120,
	"./Bachelor_010217.jpg": 121,
	"./Bachelor_010223.jpg": 122,
	"./Bachelor_010231.jpg": 123,
	"./Bachelor_010233.jpg": 124,
	"./Bachelor_010239.jpg": 125,
	"./Bachelor_010241.jpg": 126,
	"./Bachelor_010243.jpg": 127,
	"./Bachelor_010247.jpg": 128,
	"./Bachelor_010253.jpg": 129,
	"./Bachelor_010257.jpg": 130,
	"./Bachelor_010259.jpg": 131,
	"./Bachelor_010261.jpg": 132,
	"./Bachelor_010265.jpg": 133,
	"./Bachelor_010271.jpg": 134,
	"./Bachelor_010275.jpg": 135,
	"./Bachelor_010277.jpg": 136,
	"./Bachelor_010279.jpg": 137,
	"./Bachelor_010285.jpg": 138,
	"./Bachelor_010287.jpg": 139,
	"./Bachelor_010289.jpg": 140,
	"./Bachelor_010293.jpg": 141,
	"./Bachelor_010295.jpg": 142,
	"./Bachelor_010299.jpg": 143,
	"./Bachelor_010301.jpg": 144,
	"./Bachelor_010303.jpg": 145,
	"./Bachelor_010309.jpg": 146,
	"./Bachelor_010311.jpg": 147,
	"./Bachelor_010321.jpg": 148,
	"./Bachelor_010327.jpg": 149,
	"./Bachelor_010335.jpg": 150,
	"./Bachelor_010341.jpg": 151,
	"./Bachelor_010347.jpg": 152,
	"./Bachelor_010349.jpg": 153,
	"./Bachelor_010353.jpg": 154,
	"./Bachelor_010357.jpg": 155,
	"./Bachelor_010361.jpg": 156,
	"./Bachelor_010369.jpg": 157,
	"./Bachelor_010397.jpg": 158,
	"./Bachelor_010401.jpg": 159,
	"./Bachelor_010403.jpg": 160,
	"./Bachelor_010405.jpg": 161,
	"./Bachelor_010413.jpg": 162,
	"./Bachelor_010427.jpg": 163,
	"./Bachelor_010429.jpg": 164,
	"./Bachelor_010439.jpg": 165,
	"./Bachelor_010447.jpg": 166,
	"./Bachelor_010449.jpg": 167,
	"./Bachelor_010453.jpg": 168,
	"./Bachelor_010463.jpg": 169,
	"./Bachelor_010467.jpg": 170,
	"./Bachelor_010471.jpg": 171,
	"./Bachelor_010473.jpg": 172,
	"./Bachelor_010477.jpg": 173,
	"./Bachelor_010481.jpg": 174,
	"./Bachelor_010517.jpg": 175,
	"./Bachelor_010519.jpg": 176,
	"./Bachelor_010521.jpg": 177,
	"./Bachelor_010523.jpg": 178,
	"./Bachelor_010524.jpg": 179,
	"./Bachelor_010525.jpg": 180,
	"./Bachelor_010529.jpg": 181,
	"./Bachelor_010531.jpg": 182,
	"./Bachelor_010533.jpg": 183,
	"./Bachelor_010537.jpg": 184,
	"./Bachelor_010541.jpg": 185,
	"./Bachelor_010547.jpg": 186,
	"./Bachelor_010551.jpg": 187,
	"./Bachelor_010555.jpg": 188,
	"./Bachelor_010559.jpg": 189,
	"./Bachelor_010569.jpg": 190,
	"./Bachelor_010575.jpg": 191,
	"./Bachelor_010577.jpg": 192,
	"./Bachelor_010583.jpg": 193,
	"./Bachelor_010587.jpg": 194,
	"./Bachelor_010589.jpg": 195,
	"./Bachelor_010595.jpg": 196,
	"./Bachelor_010601.jpg": 197,
	"./Bachelor_010605.jpg": 198,
	"./Bachelor_010609.gif": 199,
	"./Bachelor_010653.jpg": 200,
	"./Bachelor_010656.jpg": 201,
	"./Bachelor_010658.jpg": 202,
	"./Bachelor_010658a.jpg": 203,
	"./Bachelor_010659.jpg": 204,
	"./Bachelor_010660.jpg": 205,
	"./Bachelor_010661.jpg": 206,
	"./Bachelor_010662.jpg": 207,
	"./Bachelor_010663.jpg": 208,
	"./Bachelor_010664.jpg": 209,
	"./Bachelor_010665.jpg": 210,
	"./Bachelor_010685.jpg": 211,
	"./Bachelor_010686.jpg": 212,
	"./Bachelor_010687.jpg": 213,
	"./Bachelor_010688.jpg": 214,
	"./Bachelor_010689.jpg": 215,
	"./Bachelor_010690.jpg": 216,
	"./Bachelor_010691.jpg": 217,
	"./Bachelor_010692.jpg": 218,
	"./Bachelor_010693.jpg": 219,
	"./Bachelor_010694.jpg": 220,
	"./Bachelor_010695.jpg": 221,
	"./Bachelor_010696.jpg": 222,
	"./Bachelor_010697.jpg": 223,
	"./Bachelor_010698.jpg": 224,
	"./Bachelor_010699.jpg": 225,
	"./Bachelor_010700.jpg": 226,
	"./Bachelor_010705.jpg": 227,
	"./Bachelor_010706.jpg": 228,
	"./Bachelor_010713.jpg": 229,
	"./Bachelor_010714.jpg": 230,
	"./Bachelor_010715.jpg": 231,
	"./Bachelor_010716.jpg": 232,
	"./Bachelor_010728.jpg": 233,
	"./Bachelor_010732.jpg": 234,
	"./Bachelor_010734.jpg": 235,
	"./Bachelor_010735.jpg": 236,
	"./Bachelor_010737.jpg": 237,
	"./Bachelor_010738.jpg": 238,
	"./Bachelor_010739.jpg": 239,
	"./Bachelor_010742.jpg": 240,
	"./Bachelor_010743.jpg": 241,
	"./Bachelor_010751.jpg": 242,
	"./Bachelor_010753.jpg": 243,
	"./Bachelor_010779.jpg": 244,
	"./Bachelor_010783.jpg": 245,
	"./Bachelor_010786.jpg": 246,
	"./Bachelor_010791.jpg": 247,
	"./Bachelor_010792.jpg": 248,
	"./Bachelor_010794.jpg": 249,
	"./Bachelor_010795.jpg": 250,
	"./Bachelor_010796.jpg": 251,
	"./Bachelor_010800.jpg": 252,
	"./Bachelor_010809.jpg": 253,
	"./Bachelor_010810.jpg": 254,
	"./Bachelor_010812.jpg": 255,
	"./Bachelor_010814.jpg": 256,
	"./Bachelor_010825.jpg": 257,
	"./Bachelor_010827.jpg": 258,
	"./Bachelor_010829.jpg": 259,
	"./Bachelor_010830.jpg": 260,
	"./Bachelor_010853.jpg": 261,
	"./Bachelor_010854.jpg": 262,
	"./Bachelor_010855.jpg": 263,
	"./Bachelor_010856.jpg": 264,
	"./DSC_2590.jpg": 265,
	"./DSC_2645.jpg": 266,
	"./DSC_2655.jpg": 267,
	"./DSC_2660.jpg": 268,
	"./DSC_2661.jpg": 269,
	"./DSC_2666.jpg": 270,
	"./DSC_2672.jpg": 271,
	"./DSC_2677.jpg": 272,
	"./DSC_2678.jpg": 273,
	"./DSC_2684.jpg": 274,
	"./DSC_2687.jpg": 275,
	"./DSC_2692.jpg": 276,
	"./DSC_2694.jpg": 277,
	"./DSC_2695.jpg": 278,
	"./DSC_2700.jpg": 279,
	"./DSC_2704.jpg": 280,
	"./DSC_2705.jpg": 281,
	"./IMG_3395.jpg": 282,
	"./IMG_3754.jpg": 283,
	"./IMG_3767.jpg": 284,
	"./IMG_3802.jpg": 285,
	"./IMG_5463.jpg": 286,
	"./akkuschrauber.png": 287,
	"./amp.png": 288,
	"./amp2.png": 289,
	"./bambus.gif": 290,
	"./braun_wecker.gif": 291,
	"./club-mate.png": 292,
	"./earplugs.png": 293,
	"./glaeser.jpg": 294,
	"./goldwand.jpg": 295,
	"./magazine.jpg": 296,
	"./nikon.jpg": 297,
	"./notebooks.jpg": 298,
	"./pflanzen.jpg": 299,
	"./platten.jpg": 300,
	"./portrait.jpg": 301,
	"./schlauch.gif": 302,
	"./taschenmesser.jpg": 303,
	"./usb-soundstick.jpg": 304,
	"./vasen.jpg": 305
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Main__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main___default.a
  }]
}));

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(318),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalize_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScroll;
function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    document.body.addEventListener('click', function (event) {
      if (event.target.id === 'skipintro') {
        var body = document.body;
        var grid = document.querySelector('.grid');
        body.classList.remove('animation');
        body.classList.remove('animation--delayed');
        body.offsetHeight;
        body.classList.add('animation');

        grid.classList.remove('animation');
        grid.classList.remove('animation--delayed');
        grid.offsetHeight;
        grid.classList.add('animation');
      }
    });
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Items__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Items___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Items__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_masonry_layout__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imagesloaded__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imagesloaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_instafeed_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_instafeed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_instafeed_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'items': __WEBPACK_IMPORTED_MODULE_0__components_Items___default.a
  },
  data: function data() {
    return {
      items: []
    };
  },
  mounted: function mounted() {
    var self = this;
    // To get tagged photos you need the `public_content` scope.
    // https://github.com/stevenschobert/instafeed.js/issues/408#issuecomment-256345776
    // http://instagramwordpress.rafsegat.com/docs/get-access-token/
    var feed = new __WEBPACK_IMPORTED_MODULE_3_instafeed_js___default.a({
      get: 'tagged',
      tagName: 'liebdinge',
      accessToken: '227678620.ba4c844.bb9bd1233783406bbc8be071c19515af',
      resolution: 'standard_resolution',
      mock: true,
      limit: 100,
      success: function success(images) {
        images.data.forEach(function (image) {
          var img = {
            profile: image.user.profile_picture,
            name: image.id,
            description: image.user.username,
            image: image.images.standard_resolution.url,
            story: image.caption.text,
            link: image.link,
            width: 6,
            height: 6
          };
          self.items.push(img);
        });
      },
      after: function after() {
        var instafeed = new __WEBPACK_IMPORTED_MODULE_1_masonry_layout___default.a('.instafeed', {
          itemSelector: '.item',
          columnWidth: 28,
          gutter: 40
        });
        __WEBPACK_IMPORTED_MODULE_2_imagesloaded___default()('.instafeed', function () {
          instafeed.reloadItems();
          instafeed.layout();
        });
      }
    });
    feed.run();
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item',
  props: ['item', 'index', 'previousItem', 'nextItem'],
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_1__components_Modal___default.a
  },
  data: function data() {
    return {
      show: false
    };
  },

  computed: {
    imagePath: function imagePath() {
      var image = this.item.image;
      var path = image.indexOf('http') === 0 ? image : __webpack_require__(36)("./" + image);
      return path;
    }
  },
  methods: {
    itemWidth: function itemWidth(item) {
      return item.width ? 'item--width' + item.width : '';
    },
    itemHeight: function itemHeight(item) {
      return item.height ? 'item--height' + item.height : '';
    },
    isItemDisabled: function isItemDisabled() {
      return !this.item.name || this.item.width !== this.item.height || this.item.type === 'collection';
    },
    hideModal: function hideModal() {
      this.show = false;
    },
    showModal: function showModal() {
      if (this.isItemDisabled()) {
        return;
      }
      this.show = true;
      this.$emit('active', this.index);
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$emit('showModal', true);
      document.querySelector('body').style.overflow = 'hidden';
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$on('showModal', function (show) {
      if (!show) {
        _this.hideModal();
        _this.$emit('active', null);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$on('showPrevious', function (isInstafeed) {
      _this.hideModal();
      if (_this.index === _this.previousItem && _this.$el.closest('.instafeed') === isInstafeed) {
        _this.showModal();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$on('showNext', function (isInstafeed) {
      _this.hideModal();
      if (_this.index === _this.nextItem && _this.$el.closest('.instafeed') === isInstafeed) {
        _this.showModal();
      }
    });
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Item__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grid',
  props: ['items'],
  data: function data() {
    return {
      elements: this.items,
      activeItem: null
    };
  },

  components: {
    'item': __WEBPACK_IMPORTED_MODULE_0__components_Item___default.a
  },
  computed: {
    previousItem: function previousItem() {
      return this.getPreviousItem(this.activeItem);
    },
    nextItem: function nextItem() {
      return this.getNextItem(this.activeItem);
    }
  },
  methods: {
    active: function active(index) {
      this.activeItem = index;
    },
    isItemDisabled: function isItemDisabled(item) {
      return !item.name || item.width !== item.height || item.type === 'collection';
    },
    getPreviousItem: function getPreviousItem(index) {
      var items = this.items.slice(0, index);
      for (var i = items.length - 1; i >= 0; i--) {
        if (!this.isItemDisabled(items[i])) {
          return i;
        }
      }
    },
    getNextItem: function getNextItem(index) {
      var items = this.items.slice(index + 1, this.items.length);
      var i = index + 1;
      for (var j = 0; j < items.length; j++) {
        if (!this.isItemDisabled(items[j])) {
          return i;
        }
        i += 1;
      }
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(32);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    target: String,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  render: function render() {
    this.$el = this.$el.nextSibling;
  },
  mounted: function mounted() {
    this.$el.addEventListener('click', this.handler);
  },


  methods: {
    handler: function handler() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(this.target, this.options);
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Items__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Items___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Items__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Instagram__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Instagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Instagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imagesloaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navigation__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Navigation__);
//
//
//
//
//
//
//
//
//
//







var _data = __webpack_require__(88);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main',
  data: function data() {
    return {
      items: _data.items,
      gridClass: 'masonry'
    };
  },

  components: {
    'items': __WEBPACK_IMPORTED_MODULE_0__components_Items___default.a,
    'instagram': __WEBPACK_IMPORTED_MODULE_1__components_Instagram___default.a,
    'navigation': __WEBPACK_IMPORTED_MODULE_4__components_Navigation___default.a
  },
  mounted: function mounted() {
    var msnry = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a('.masonry', {
      itemSelector: '.item',
      columnWidth: 28,
      gutter: 40
    });
    __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default()('.masonry', function () {
      msnry.reloadItems();
      msnry.layout();
    });
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item'],
  data: function data() {
    return {
      activeImage: 0,
      modalImage: this.item.image
    };
  },

  methods: {
    imagePath: function imagePath(image) {
      if (!image) {
        return;
      }
      var path = this.isExternalImage(image) ? image : __webpack_require__(36)("./" + image);
      return path;
    },
    isExternalImage: function isExternalImage(imageUrl) {
      if (!imageUrl) {
        return;
      }
      return imageUrl.indexOf('http') === 0;
    },
    hideModal: function hideModal(event) {
      if (event && event.target.className !== 'modal') {
        return;
      }
      this.activeImage = 0;
      this.modalImage = this.item.image;
      this.$emit('hide', null);
      document.querySelector('body').style.overflow = null;
      __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* default */].$emit('showModal', false);
    },
    setActiveImage: function setActiveImage(image, index) {
      this.activeImage = index;
      this.modalImage = image.image;
    },
    showPrevious: function showPrevious() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* default */].$emit('showPrevious', this.$el.closest('.instafeed'));
    },
    showNext: function showNext() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* default */].$emit('showNext', this.$el.closest('.instafeed'));
    },
    escapeKeyListener: function escapeKeyListener(event) {
      if (event.keyCode === 27) {
        this.hideModal();
      }
    },
    leftKeyListener: function leftKeyListener(event) {
      if (event.keyCode === 37) {
        this.showPrevious();
      }
    },
    rightKeyListener: function rightKeyListener(event) {
      if (event.keyCode === 39) {
        this.showNext();
      }
    }
  },
  mounted: function mounted() {
    var el = this.$el;
    /* eslint-disable no-undef */
    var observer = new WebKitMutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var name = mutation.attributeName;
        var newValue = mutation.target.getAttribute(name);
        if (name === 'style' && !newValue) {
          el.focus();
        }
      });
    });
    observer.observe(el, { attributes: true, subtree: false });
    el.addEventListener('mouseover', el.focus());
    el.addEventListener('keyup', this.leftKeyListener);
    el.addEventListener('keyup', this.rightKeyListener);
  },
  created: function created() {
    window.addEventListener('keyup', this.escapeKeyListener);
    if (this.item.items) {
      this.item.items = [{ name: this.item.name, image: this.item.image }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.item.items));
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.escapeKeyListener);
    window.removeEventListener('keyup', this.leftKeyListener);
    window.removeEventListener('keyup', this.rightKeyListener);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Jump__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Jump___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Jump__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jump_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    'jump': __WEBPACK_IMPORTED_MODULE_2__components_Jump___default.a,
    'modal': __WEBPACK_IMPORTED_MODULE_1__components_Modal___default.a
  },
  data: function data() {
    return {
      visible: false,
      show: false,
      about: {
        name: 'Michael Wallner',
        description: 'MedienDesigner  |  1987 geboren | <a href="http://michi-wallner.de">http://michi-wallner.de</a>',
        image: 'portrait.jpg',
        story: 'Hallo, durch meine Dinge hast du bereits einiges über mich erfahren. Warum ich dieses Projekt mache? Ich möchte dazu anregen den Umgang mit Dingen und deren Wertschätzung zu reflektieren. Denn Dinge können bereichern, prägen, nerven und lassen uns erinnern wer wir sind. Ich freue mich jederzeit über Feedback zu liebdinge.com und über dein Lieblingsding auf Instagram unter #liebdinge.',
        hideNavigation: true
      }
    };
  },
  mounted: function mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$on('showModal', function (value) {
      _this.modal(!value);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      this.visible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getScroll */])(window, true) > this.visibilityHeight;
    },
    scrollToTop: function scrollToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_jump_js__["a" /* default */])(document.body, this.options);
    },
    showModal: function showModal() {
      this.show = true;
      this.$emit('active', this.index);
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* default */].$emit('showModal', true);
      document.querySelector('body').style.overflow = 'hidden';
    },
    modal: function modal(value) {
      this.visible = value;
    }
  }
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

module.exports = {"items":[{"name":"Bandshirt","description":"Fjørt  |  2016 gekauft","image":"Bachelor_010481.jpg","story":"Auf einem Livekonzert die Band entdeckt und das Shirt neben einem anderen gekauft."},{"name":"Schallplatte","description":"Smashing Pumpkins: Mellon Collie and the infinite Sadness  |  2012 gekauft","image":"Bachelor_010265.jpg","story":"Eine der teuersten Platten, die ich mir je gekauft habe. Hauptsächlich wegen einem Song: Zero. Kostenpunkt: 70€"},{"name":"Jeansjacke","description":"Levi's Strauss 71670  |  2016 gebraucht gekauft","image":"Bachelor_010335.jpg","story":"In einem Secondhandladen in Kopenhagen gekauft, als ein Kommilitone mich dort besucht hat. Der Laden war so skurril und wir fanden das sehr lustig uns dort Jacken für’s kalte Auslandsemester zu kaufen. Jeder ging mit 2 Stück raus."},{"name":"Fahrradrahmen","description":"focale 44  |  2011 gebraucht gekauft","image":"Bachelor_010551.jpg","story":"Bei Ebay ersteigert. Sollte ein Stadtrad werden. Plan nie in die Tat umgesetzt, seitdem steht es unbenutzt in einer Ecke."},{"name":"Hausschuhe","description":"Plüschpantoffeln P24  |  2017 gekauft","image":"Bachelor_010735.jpg","story":"Auf Empfehlung eines befreundeten Pärchens gekauft von Jünemann's Pantoffeleck in Berlin. Rutscht sich gut in der Wohnung und sind bequem."},{"name":"Schallplatte","description":"letlive: Fake History  |  2014 gekauft","image":"Bachelor_010293.jpg","story":"Durch Musikhören mit einem Freund entdeckt und seither sehr begeistert von dieser Band. Erinnert mich immer noch an den Winter 2012/2013 in dem wir nächtelang Musik gehört haben. Lieblingssongs: The Sick, Sick, 6.8 Billion und Mother."},{"name":"Wörterbuch","description":"Langenscheidts Schulwörterbuch Englisch  |  1995 erhalten","image":"Bachelor_010706.jpg","story":"Ein Wörterbuch, dessen Einband mir als Kind nicht gefiel. Daraufhin in weißes Papier eingebunden. Steht immer noch in meinem Bücherregal, obwohl ich heute alles im Netz nachschlage."},{"name":"Wok","description":"Unbekanntes Fabrikat  |  1997 erhalten","image":"0754.jpg","story":"Pfanne, mit der ich das Kochen gelernt habe. Mein liebstes von mir selbst gekochtes Gericht: Asiatisches Gemüse mit Nudeln aus dem Wok. Gibt’s phasenweise täglich."},{"name":"Fahrradmütze","description":"Campagnolo  |  2012 gekauft","image":"0755.jpg","story":"Dachte ich, müsste man haben als ich eine Zeit lang sehr gerne Rennrad gefahren bin. Wird aber nicht getragen."},{"name":"Staubwedel","description":"Lammwolle  |  2017 gekauft","image":"0776.jpg","story":"Ich war lange der Meinung dass Staubwedel nur den Staub verteilen, bis ich eines Besseren belehrt wurde. Bin begeistert."},{"name":"Brille","description":"FunkRoyal Bukephalos  |  2012 gekauft","image":"0756.jpg","story":"In den letzten Jahren eine Sehschwäche bekommen und 2012 eine Brille geholt. Wird aber nur noch beim Autofahren getragen. Brille tragen ist nicht so meins."},{"name":"Buch","description":"Golf Praxis Buch  |  2003 erhalten","image":"0765.jpg","story":"Wollte mal Golf lernen und hab dieses Buch geschenkt bekommen. Muss heute darüber schmunzeln, drum behalte ich es."},{"name":"Schallplatte","description":"Daft Punk: Random Access Memories  |  2016 gekauft","image":"Bachelor_010783.jpg","story":"Der Sound des Albums ist trocken und nicht lärmend – auch wenn es lauter gehört wird als jede andere Platte."},{"name":"Super 8-Film-Betrachter","description":"Braun SB2  |  2006 erhalten","image":"Bachelor_010695.jpg","story":"Aus dem Equipment meines Großvaters, der Urlaubserlebnisse mit Super 8 dokumentiert und mit diesem Gerät Schnittmarken gesetzt hat. Kürzlich haben Leute über ein Nachbarschaftsportal nach einem Super 8 Betrachter gefragt – und ich konnte damit aushelfen."},{"name":"Taschenuhr","description":"Unbekanntes Fabrikat  |  2013 gebraucht gekauft","image":"Bachelor_010728.jpg","story":"Ein Geschenk an meine Freundin, leider ging die Uhr ein paar Wochen nach dem Kauf kaputt. Seither liegt sie bei mir, um mal danach zu sehen."},{"name":"Schallplatte","description":"Death Cab For Cutie: Plans  |  2009 gekauft","image":"Bachelor_010233.jpg","story":"2009 in einem Plattenladen in New York, Greenwich Village gekauft. Gezielt danach gesucht, weil diese Platte zu der Zeit nicht in Deutschland erhältlich war. Wurde so zu einem Erinnerungsstück an einen New York-Urlaub mit meiner Freundin."},{"name":"Cinchkabel","description":"Unbekanntes Fabrikat  |  2004 gekauft","image":"Bachelor_010738.jpg","story":"Die Kabel erinnern mich an meine Zeit mit ungefähr 13 Jahren, in der ich oft bei einem Highend Hifi-Ladenbesitzer zu Besuch war und mich mit ihm angefreundet hab. Er freute sich über meine Begeisterung für Highend Hifi."},{"name":"Stativ","description":"Unbekanntes Fabrikat  |  2012 gebraucht gekauft","image":"Bachelor_010737.jpg","story":"Auf dem Flohmarkt gekauft und einem Arbeitskollegen gezeigt, der totaler Minimalist ist. Er so: „Und das legst du dir jetzt unters Sofa oder was?“ – am Ende wurde es das Regal."},{"name":"Pudding","description":"Alnatura Vanille Pudding  |  seit 2017 im Verbrauch","image":"0762.jpg","story":"Wird fast täglich zum Nachtisch gegessen. Superlecker."},{"name":"Schallplatte","description":"Warm Graves: Ships Will Come  |  2017 gekauft","image":"Bachelor_010303.jpg","story":"Erinnerungsstück an einen schönen Moment. Nach einer durchzechten Nacht morgens um 6 noch Musik gehört und diese Platte gezeigt bekommen."},{"name":"Topfpflanze","description":"Japanischer Fächerahorn  |  2000 gekauft","image":"Bachelor_010825.jpg","story":"Bei einem Gärtnereibesuch mit meinen Großeltern gekauft. Seit 17 Jahren Bewohner meines Balkons."},{"name":"Stehlampe","description":"Unbekanntes Fabrikat  |  2009 erhalten","image":"Bachelor_010854.jpg","story":"Eine aussortierte Lampe meiner Eltern, die Zuhause bei Renovierungen als Baustellenlicht verwendet wurde. Hat mir gefallen und dient jetzt als Wohnzimmerbeleuchtung."},{"name":"Zeichnung","description":"gerahmt  |  2014 erstellt","image":"0773.jpg","story":"Eine Zeichnung die mich an den Formgestaltungskurs im Studium erinnert – Gute Erinnerungen."},{"name":"Pfeffermühle","description":"WMF  |  2013 erhalten","image":"Bachelor_010713.jpg","story":"Manchmal tendiere ich bei Dingen dazu, sie mir etwas zu groß zu kaufen. Ich mag diese Mühle aber kleiner wäre handlicher."},{"name":"Buch","description":"Der goldene Kompass  |  1995 erhalten","image":"Bachelor_010159.jpg","story":"Mein Lieblingsbuch als Kind. Es ließ eine fantastische Vorstellungswelt entstehen, an die ich mich heute noch erinnern kann. Ich war bitter enttäuscht, als die Verfilmung Jahre später ins Kino kam."},{"name":"Backgammon Spiel","description":"Kunstlederkoffer  |  2008 gekauft","image":"Bachelor_010177.jpg","story":"Mit diesem Backgammon Spiel und einem guten Freund habe ich unzählige gute Abende in Freiburger Straßencafés verbracht."},{"name":"DVD","description":"Leaving Las Vegas  |  2006 gekauft","image":"Bachelor_010193.jpg","story":"Einer der schönsten melancholischen Filme zum alleine Schauen."},{"name":"Schallplatte","description":"Alexisonfire: Watch Out  |  2006 gekauft","image":"Bachelor_010241.jpg","story":"Seit über 10 Jahren eine meiner Lieblingsplatten."},{"name":"Schallplatte","description":"Jacks Mannequin: Everything in Transit  |  2012 gekauft","image":"Bachelor_010295.jpg","story":"Durch einen meiner ältesten und engsten Freunde entdeckt. Habe jahrelang nach der Platte gesucht, bis ich sie endlich auftreiben konnte."},{"name":"iPod","description":"Apple ipod Video 30gb  |  2005 gekauft","image":"Bachelor_010537.jpg","story":"Musik zu hören war mir schon immer wichtig. Hat eine neue Dimension bekommen, als ich meine komplette Musiksammlung auf einmal überall mit hinnehmen konnte."},{"name":"Handy","description":"Nokia N90  |  2005 gekauft","image":"Bachelor_010531.jpg","story":"Das Gerät konnte umgeklappt werden zu einem kleinen Camcorder. Die Kamera war damals verhältnissmäßig gut. Ein skurriles Erinnerungsstück."},{"name":"Schallplatte","description":"We Never Learned To Live: Silently I Threw Them Skyward – Tour Edition  |  2016 gekauft","image":"Bachelor_010309.jpg","story":"Auf einem Konzert gekauft, auf dem diese Band Vorband war. Nur den letzten Song der Vorband gehört, danach die Band Fjørt entdeckt."},{"name":"Schuhe","description":"Supra Muska Hightop  |  2007 gekauft","image":"Bachelor_010696.jpg","story":"Ungefähr 4 Jahre fast jeden Tag getragen. Meine Schuhe, die am längsten gehalten haben. Danach noch 2 Mal ein ähnliches Modell gekauft. War keines so bequem wie das erste."},{"name":"Bandshirt","description":"Juvenalis  |  2011 gekauft","image":"Bachelor_010357.jpg","story":"Gekauft, als ich 2011 auf einem Konzert der Band war. Die Band hat sich mittlerweile aufgelöst. Heute sind 2 der Mitglieder 2 meiner engsten Freunde."},{"name":"Pullover","description":"H&M  |  2014 gekauft","image":"Bachelor_010347.jpg","story":"Den Pullover gab es im Ausverkauf für 3€. Hab ihn gleich 2 Mal gekauft."},{"name":"Schallplatte","description":"Thursday: Full Collapse  |  2011 gekauft","image":"Bachelor_010301.jpg","story":"War früher mein Lieblingsalbum und ist immer noch einer meiner absoluten Favoriten. Eine Platte die ich lange gesucht habe."},{"name":"Schallplatte","description":"Fjørt: Demontage  |  2016 gekauft","image":"Bachelor_010257.jpg","story":"Die Band hab ich 2016 live entdeckt auf einem Konzert das ausverkauft war und wir nur mit viel Überredungskunst noch reinkamen. Am Merchandisestand die Platte gekauft."},{"name":"USB Sound Adapter","description":"Tecknet  |  2016 gekauft","image":"usb-soundstick.jpg","story":"Mein Notebook spielte keinen Ton mehr ab, nachdem ich mit meiner Schlagbohrmaschine eine Stromleitung in der Wand erwischt hatte. Der USB Adapter mit Audioausgang (für 6€ anstatt einer Reparatur über 600€) war die günstigere Lösung."},{"name":"Portwein","description":"Ferreira Porto weiß  |  2017 gekauft","image":"Bachelor_010697.jpg","story":"Souvenir von der Studienexkursion im April 2017 nach Porto, Portugal. Bisher aber noch nicht geöffnet, weil ich immer lange auf den vermeintlich richtigen Moment dafür warte und dann vergesse, dass ich das Ding hab."},{"name":"Wecker","description":"ostar d40  |  2014 erhalten","image":"Bachelor_010687.jpg","story":"Ein Geschenk von meiner Freundin. Sie mag solche winzige Sachen."},{"name":"Bandshirt","description":"Architects  |  2015 erhalten","image":"Bachelor_010349.jpg","story":"Von einer guten Freundin zum Geburtstag geschenkt bekommen, weil ich sie immer mit meiner Obsession für diese Band vollgetextet hab.","width":"2","height":"2"},{"name":"Spiegelreflexkamera","description":"Konica Autoreflex TC  |  2012 gebraucht gekauft","image":"Bachelor_010700.jpg","story":"Gekauft als ich mit analogen Fotos experimentierte. Kamera mit Zoomobjektiv zum Schieben statt zum Drehen. Hat sich aber nicht gegen die alte Kamera durchgesetzt und steht jetzt im Regal."},{"name":"Feuerzeug","description":"Zippo  |  2004 gekauft","image":"Bachelor_010691.jpg","story":"Kurz nachdem ich das Rauchen anfing gekauft. Jahrelang benutzt und auch mal 2 Tricks gelernt. Irgendwann die Jack Daniels Plakette vorn abgemacht, die ursprünglich dran war. Hab ich nie getrunken, war wohl so ein Ding das damals im Trend war.","items":[{"name":"Feuerzeug","image":"Bachelor_010692.jpg"}]},{"name":"Eierbecher","description":"Glas  |  2003 erhalten","image":"Bachelor_010715.jpg","story":"Eins dieser Objekte die man nie braucht, ich zumindest nicht. Finde die aber seltsam schön und lass die einfach im Regal funkeln."},{"name":"Bandshirt","description":"Slow Bloomer  |  2017 gekauft","image":"Bachelor_010341.jpg","story":"Ein Freund hat ein Konzert mit dieser Band veranstaltet. Erst am selben Tag davon erfahren, hingegangen, begeistert. Shirt und deren Platte gekauft."},{"name":"Buch","description":"Fraktur mon amour  |  2014 erhalten","image":"Bachelor_010519.jpg","story":"Ein Buch über Frakturschriften. Verwende ich für die Arbeit und schmökere auch privat darin. Mittlerweile ein Sammlerstück. Ein Geschenk von meiner Mutter – eine Wunscherfüllung."},{"name":"Schallplatte","description":"Oceansize: Effloresce  |  2009 gekauft","image":"Bachelor_010277.jpg","story":"Die Platte erinnert mich immer an die Abende bei einem Freund und früheren Arbeitskollegen mit dem ich früher viel Musik gehört habe."},{"name":"Schallplatte","description":"Jimi Hendrix: Axis Bold As Love  |  2003 gekauft","image":"Bachelor_010239.jpg","story":"Mein allererstes Album auf Platte. Gekauft, als ich noch keinen Plattenspieler, aber die Intention hatte, mir einen anzuschaffen."},{"name":"Kurze Hose","description":"Rhythm  |  2009 erhalten","image":"Bachelor_010369.jpg","story":"Geschenkt bekommen, als ein Freund bei eben jenem Klamottenlabel anfing zu arbeiten. Hätte ich mir selber nie ausgesucht, aber ich mag sie wegen der verschiedenen Linienstärken. Und sie erinnert mich an einen Wochenendbesuch bei ihm."},{"name":"Bandshirt","description":"Mutiny on the Bounty  |  2016 gekauft","image":"Bachelor_010327.jpg","story":"Auf einem Konzert in Kopenhagen gekauft, wo ich diese Band zum 2. Mal live gesehen habe. Nach beiden Konzerten lange mit dem Schlagzeuger unterhalten und von ihm erfahren, dass deren Musik gar nicht so sein Ding sei. Sind trotzdem sehr erfolgreich und touren durch die ganze Welt."},{"name":"Aschenbecher","description":"Quist Kugelaschenbecher  |  2003 erhalten","image":"Bachelor_010714.jpg","story":"Bei meinen Großeltern in der Wohnung gesehen und nachgefragt, warum der dort steht. Daraufhin von meinem Großvater Geschichten von früher erzählt und den Aschenbecher geschenkt bekommen. Nicht weil er mich zum Rauchen animieren wollte, sondern als Erinnerungsstück."},{"name":"Akkuschrauber","description":"Bosch Professional  |  2013 gekauft","image":"0772.jpg","story":"Ein langlebiges und mein meistbenutztes Elektrowerkzeug. Hat schon einiges mitgemacht und einen minderwertigen Akkuschrauber ersetzt."},{"name":"Schallplatte","description":"Foals: Total Life Forever  |  2010 gekauft","image":"Bachelor_010253.jpg","story":"Durch einen Freund beim Musikhören Abends entdeckt und vielen anderen Freunden gezeigt, die alle davon begeistert waren. Mein Vater hat sich die Scheibe auch damals gekauft. Favorit auf dem Album: Spanish Sahara"},{"name":"Sprechanlage","description":"Siedle LN 7145 W  |  2017 gebraucht gekauft","image":"Bachelor_010397.jpg","story":"Die Sprechanlage habe ich passend zur Altbau-Wohnung gekauft. Der Hersteller Siedle hat das System seit Jahrzehnten kompatibel weiterentwickelt, somit ist es auch rückwärts kompatibel mit dem ersten Model.","width":"5","height":"5"},{"name":"Topfpflanze","description":"Orchidee  |  2005 erhalten","image":"0771.jpg","story":"Ein Geschenk meiner Mutter zum 18. Geburtstag. Wächst trotz Pflege nicht so richtig. Der Topf ist aus Berlin von einem Wochenendtrip."},{"name":"Sonnenbrille","description":"Fielmann  |  2014 gekauft","image":"0757.jpg","story":"Sobald gutes Wetter ist wird die getragen. Bin lichtempfindlich. Als Kind schon im Kinderwagen geniest sobald die Sonne rauskam."},{"name":"Etikettiermaschine","description":"Dymo 1710  |  2017 erhalten","image":"0758.jpg","story":"Von einem Arbeitskollegen geschenkt bekommen, da er um mein Faible zu ausgefallenen Dingen weiß."},{"name":"Schallplatte","description":"Benton Falls: Fighting Starlight  |  2010 gekauft","image":"Bachelor_010243.jpg","story":"Erinnert mich an Sommerabende und die erste eigene Wohnung in Freiburg. Die Platte hab ich extra aus den Staaten bestellt."},{"name":"Vase","description":"iittala Vase Alvar aalto  |  2002 erhalten","image":"DSC_2705.jpg","story":"In der Jugend anstatt eines Adventskalenders bekommen. Immer noch ein Lieblingsstück."},{"name":"Schallplatte","description":"Bon Iver: Bon Iver  |  2011 gekauft","image":"Bachelor_010261.jpg","story":"Ein unfassbar schönes und melancholisches Album und eine meiner meistgespielten Platten."},{"name":"Flex","description":"Bosch Professional  |  2012 gekauft","image":"Bachelor_010447.jpg","story":"Die kleine Schwester meiner großen Flex. Nach dem Akkuschrauber mein meist verwendetes Elektro-Werkzeug. Damit wurde eine schöne alte Bank in meinem Garten restauriert."},{"name":"Spielkarten","description":"Unbekannter Hersteller  |  2009 gebraucht gekauft","image":"Bachelor_010732.jpg","story":"Auf dem Flohmarkt entdeckt. Ich mag die Illustrationen und wie klein die Karten sind."},{"name":"Stift","description":"Unbekannter Hersteller  |  2014 gekauft","image":"Bachelor_010794.jpg","story":"Ein Kugelschreiber in der Hülle eines klassischen Holzstifts mit extrem feiner Mine. Passend für meine kleine Handschrift."},{"name":"Schallplatte","description":"Poliça: Give you the Ghost  |  2017 erhalten","image":"Bachelor_010271.jpg","story":"Von einem sehr guten Freund zum 30. Geburtstag geschenkt bekommen – eine Wunscherfüllung."},{"name":"Armband","description":"selbst gemacht  |  2016 erhalten","image":"Bachelor_010795.jpg","story":"Ein Geschenk meiner Freundin, das ich fast täglich trage."},{"name":"Beistelltisch","description":"Habitat  |  2005 gekauft","image":"Bachelor_010855.jpg","story":"Beim Familienbesuch gekauft und vergessen, wie weit das Auto weggeparkt war. Einmal durch die komplette Stadt geschleppt."},{"name":"Fahrradrahmen","description":"Unbekanntes Fabrikat  |  2012 gebraucht gekauft","image":"Bachelor_010547.jpg","story":"Zusammen mit mehreren anderen Rädern gekauft. Viele andere Räder gebaut, so dass dieser Rahmen unbenutzt blieb. Vor einem Jahr ein neues Tretlager einbauen lassen. Wartet auf neue Verwendung."},{"name":"Schallplatte","description":"Thrice: The Alchemy Index  |  2010 gekauft","image":"Bachelor_010311.jpg","story":"Ein Konzeptalbum, das aus vier 10“ Platten besteht und jeweils eines der vier Elemente behandelt, so auch das Vinyl selbst. Die Platte habe ich mir aus England bestellt und Jahre später beim Katalogisieren meiner Plattensammlung festgestellt, dass die Platte mittlerweile ab 300€ gehandelt wird. Behalte ich aber.","items":[{"name":"Schallplatte","image":"Bachelor_010321.jpg"}]},{"name":"Modellauto","description":"Maisto 1967 Ford Mustang GT 1:24  |  2014 gekauft","image":"0764.jpg","story":"Klischee, aber ich hab mein Traumauto als Modellauto. In echt sollte es aber schwarz sein."},{"name":"Bandshirt","description":"Midnight Service Center  |  2006 gekauft","image":"Bachelor_010361.jpg","story":"Mein ältestes Bandhirt, das ich noch besitze. Nicht aussortiert, obwohl es zu klein ist, gelbe Schweißränder hat und ich es nicht mehr anziehe."},{"name":"Locher","description":"Leitz 18  |  2007 erhalten","image":"Bachelor_010698.jpg","story":"Den hatten meine Eltern schon seit ich denken kann. Erinnerungsstück an deren gemeinsames Arbeitszimmer, in dem meine Mutter ihre Arbeiten für ihr Grafikstudium anfertigte."},{"name":"Locher","description":"Leitz No. 58  |  2010 gebraucht gekauft","image":"Bachelor_010705.jpg","story":"Scheren und Locher wandern bei mir und meiner Freundin stets auf wundersame Weise durch die Wohnung. Ein weiterer Wanderer."},{"name":"Schallplatte","description":"Mutiny on the Bounty: Digital Tropics  |  2015 gekauft","image":"Bachelor_010279.jpg","story":"Bei einem Konzert in Karlsruhe mit einem Arbeitskollegen gesehen und gekauft. Nach dem Konzert noch lange mit dem Schlagzeuger unterhalten."},{"name":"Pfanne","description":"Gusseisen  |  2014 erhalten","image":"Bachelor_010779.jpg","story":"Von der Mutter meiner Freundin geschenkt bekommen. Ein Familienerbstück von ihrer Großmutter. Verwende ich oft und gerne."},{"name":"Schlüsselbund","description":"Karabiner  |  2015 gekauft","image":"Bachelor_010743.jpg","story":"Ich trage den Schlüsselbund an einem Karabiner an einer Gürtelschlaufe. Werde von Freunden und Kollegen schon am Geklimper erkannt, das ich wegen meiner Schwerhörigkeit nur durch deren Reaktionen wahrnehme. Hat mir den Spitznamen Hausmeister eingebracht."},{"name":"Koffer","description":"Leder  |  2011 gebraucht gekauft","image":"Bachelor_010830.jpg","story":"Auf einem Haushaltsbasar für 1 Euro das Stück gekauft. Mochte die Farbkombination. Dient als Aufbewahrung auf dem Schrank für selten benutze Dinge, wie beispielsweise lustige Kleidungsstücke für Mottoparties."},{"name":"Schallplatte","description":"Thrice: Beggars  |  2009 gekauft","image":"Bachelor_010299.jpg","story":"Das Album mit dem Song „Talking Through Glass / We Move Like Swing Sets“ hat mich völlig umgehauen. Außerdem eine sehr schöne Ballade auf dem Album: „Circles“. Das Album verbindet mich auch mit meinem Vater, weil wir diesen Musikgeschmack teilen."},{"name":"Sturmlaterne","description":"Feuerhand  |  2015 erhalten","image":"Bachelor_010856.jpg","story":"Nachdem ich mehrere Sturmlaternen vom Flohmarkt gekauft hatte, die nicht gut funktionierten, bekam ich diese von meiner Freundin geschenkt. Mach ich gerne an."},{"name":"Mixtape","description":"Kassette  |  2012 erhalten","image":"0770.jpg","story":"An Weihnachten werden in meinem Freundeskreis Mixtapes gewichtelt. Das hier war das Beste mit selbst eingesprochenem Sampler und lustig verstellter Stimme am Anfang: „Herzlichen Glückwunsch, dass du dieses Tape gewichtelt hast.“ Fand ich super.","items":[{"name":"Mixtape","image":"Bachelor_010791.jpg"},{"name":"Mixtape","image":"Bachelor_010792.jpg"}]},{"name":"Fahrrad-Gabel","description":"Chrom  |  2011 gebraucht gekauft","image":"Bachelor_010429.jpg","story":"Die Gabel an meinem Rennrad sollte aus optischen Gründen gegen diese getauscht werden. Bisher noch nicht gemacht. Steht auf meinem Schrank seit 2012."},{"name":"Polsterstuhl","description":"stoff grün, Holz  |  2011 erhalten","image":"Bachelor_010587.jpg","story":"Im Regen beim Sperrmüll vor einem Hotel gefunden, aus dem er zu stammen schien. Bis auf den weißen Fleck und ein paar Kratzern völlig intakt. Steht in meinem Zimmer.","width":"2","height":"2"},{"name":"Zeichnung","image":"Bachelor_010453.jpg","width":"2","height":"2","story":"Anstatt einer Geburtstagskarte von 4 Freunden bekommen. Zeigt deren Köpfe als Karikatur. Hängt jetzt in meinem Zimmer."},{"name":"Spiegelreflexkamera","description":"Praktica Super TL3  |  2002 erhalten","image":"Bachelor_010663.jpg","story":"Damit hab ich fotografieren gelernt. Die alte analoge Spiegelreflexkamera meines Vaters. Ich erinnere mich noch an unsere Urlaube als ich klein war. Mein Vater hat immer minutenlang an der Kamera feinjustiert, bis er ein Foto gemacht hat."},{"name":"Übertopf","description":"Keramik  |  2016 erhalten","image":"Bachelor_010853.jpg","story":"Beim dem Sperrmüll in einer wohlhabenden Gegend entdeckt. Bis auf einen Riss noch völlig intakt. Steht im Flur der Wohnung."},{"name":"Lampe","description":"Blech  |  2008 erhalten","image":"Bachelor_010827.jpg","story":"In einer alten Stammkneipe 2 Stück davon geschenkt bekommen nach einem Umbau, weil die Besitzerin mitbekam, dass mir die alten Lampen gefielen."},{"name":"Schallplatte","description":"Moderat: Moderat  |  2010 gekauft","image":"Bachelor_010287.jpg","story":"Seit fast 10 Jahren immer noch eine meiner Lieblingsplatten. Bin begeistert von dem Artwork und deren Livekonzerten – schon 3 Mal erleben dürfen."},{"name":"Taschenmesser","description":"Victorinox  |  2012 erhalten","image":"taschenmesser.jpg","story":"Ein Geschenk der Eltern meiner Freundin. Ist sehr praktisch und jeden Tag dabei. Vor allem der 32GB USB-Stick hilft im Alltag.","width":"2","height":"2"},{"name":"Bandshirt","description":"Stray From the Path  |  2016 gekauft","image":"Bachelor_010812.jpg","story":"Erinnert mich an ein Konzert der Band in Kopenhagen 2016. Ein super Abend."},{"name":"Gitarrenverstärker","description":"Orange Micro Terror  |  2016 gekauft","image":"Bachelor_010665.jpg","story":"Ein Mikroverstärker den ich als Zweitverstärker verwende, um mit der Gitarre Stereoeffekte beim Musikmachen erzeugen zu können. Der ist so klein wie eine Lunchbox."},{"name":"E-Gitarre","description":"Gibson Les Paul Historic Collection  |  2004 Gekauft","image":"Bachelor_010413.jpg","story":"Die zweite E-Gitarre, die dem Wunsch nach einem fetteren Sound folgte, da sich der Musikgeschmack in härtere Genres bewegt hat. Seit 2005 in jeder Bandprobe dabei.","width":"6","height":"6"},{"name":"Buch","description":"Schumann’s Bar  |  2001 gekauft","image":"0768.jpg","story":"Stammt aus einer Phase, in der ich gerne klassische Cocktails mixte. Das war die Bibel dazu."},{"name":"Schallplatte","description":"Monochrome: Cache  |  2009 gekauft","image":"Bachelor_010285.jpg","story":"Die Platte erinnert mich an einen kleinen Secondhand Plattenladen in Freiburg, in dem ich früher oft war. Fundstück, verknüpft mit schönen Erinnerungen."},{"name":"Bandshirt","description":"The Tidal Sleep  |  2012 gekauft","image":"Bachelor_010471.jpg","story":"Auf einem der ersten Konzerte der Band gekauft. Lag lange vergessen im Schrank. Gefreut, als ich es wiederfand."},{"name":"Gemüsemesser","description":"Robert Herder Carbon Solingen  |  2013 erhalten","image":"Bachelor_010525.jpg","story":"Ein Geschenk meiner Mutter, das zum absoluten Lieblingsmesser wurde, so dass ich es schon 2 Mal selbst verschenkt habe. Vor kurzem jemanden kennengelernt, der genau das gleiche hat und es sich sogar tätowieren lies weil er so begeistert davon ist."},{"name":"Mixtape","description":"Kassette  |  2015 erhalten","image":"0769.jpg","story":"Geschenk eines sehr guten Freundes. Ein Mixtape mit Gute-Laune- und Sommermusik und selbst gestaltetem Cover.","items":[{"name":"Mixtape","image":"Bachelor_010786.jpg"}]},{"name":"Schlüsselanhänger","description":"Lego Star Wars C3PO  |  2016 erhalten","image":"0775.jpg","story":"Ein Geschenk meines Vaters als er mich im Auslandsemester in Dänemark besuchte. Einen Legostore besucht, heimlich gekauft und mir später überreicht. Wir spielten gerne Lego zusammen als ich klein war. An regnerischen Sonntagen sahen wir zusammen Star Wars.","width":"2","height":"2"},{"name":"Statue","description":"Coloso de Tula  |  2008 erhalten","image":"Bachelor_010685.jpg","story":"Ein Urlaubsmitbringsel meiner Eltern von ihrer Hochzeitsreise nach Mexiko. Ich hab mir die Statue bei meinem Auszug unter den Nagel gerissen, weil sie mir gefiel.","width":"5","height":"5"},{"name":"Gitarrenbox","description":"Dynacord M35  |  2003 erhalten","image":"Bachelor_010829.jpg","story":"Hatte ich jahrelang einem Freund ausgeliehen, bis er mich an das Stück erinnerte. Hat ihm lange als Tisch für Zimmerpflanzen gedient."},{"name":"Kunstwerk","description":"selbst hergestellt  |  2015 erhalten","image":"Bachelor_010401.jpg","story":"Von einem Freund, der Künstler ist, zum Geburtstag geschenkt bekommen. Einen Teil bekam meine Freundin, den anderen ich. Beton im Rahmen. Der Abdruck davon auf Leinwand. Leider ist der Betonteil bei der Party kaputtgegangen und der Klebeversuch gescheitert."},{"name":"Tagebuch","description":"Buch mit Filzhülle  |  2013 erhalten","image":"0767.jpg","story":"Von den Eltern geschenkt bekommen. Das Tagebuch über die Erlebnisse in meinen ersten Lebensjahren."},{"name":"Stuhl","description":"Frankfurter Küche Stuhl Holz  |  2012 erhalten","image":"Bachelor_010583.jpg","story":"Auf dem Sperrmüll zwei völlig intakte Exemplare dieses Stuhls gefunden. Einer davon hat mir während meines Studiums als Schreibtischstuhl gedient.","width":"3","height":"3"},{"name":"Bandshirt","description":"Architects  |  2016 gekauft","image":"Bachelor_010477.jpg","story":"Ein Shirt meiner Lieblingsband deren Gestaltung ich sehr beachtlich finde. Besonders für eine Band aus dem Genre Metal, in dem es mit der Ästhetik meistens nicht so weit her ist."},{"name":"Kamera","description":"Nikon D80  |  2005 gekauft","image":"nikon.jpg","story":"Nachdem ich mit der alten analogen Spiegelreflex meines Vaters lange experimentiert hatte, wollte ich eine digitale Kamera. Fand ich einen interessanten Gegenstand, weil man ihn erst über die Jahre schätzt, nachdem man die vielen Bilder macht.","width":"2","height":"2"},{"name":"Gartenhütte","description":"2012 gekauft","image":"06-huette.jpg","story":"Die Gartenhütte kaufte ich 2012 als Teil meines Schrebergartens. Eine der besten Investitionen bislang. 2015 wurde die Front durch alte Sprossenfenster erneuert. Gute Freunde wurden Gartennachbarn und der Garten damit doppelt so groß.","width":"6","height":"6"},{"height":"3"},{"name":"Schallplatte","description":"Pink Floyd: A Momentary Lapse Of Reason  |  2017 gekauft","image":"Bachelor_010275.jpg","story":"Von meinem Vater ans Herz gelegt bekommen. Er hat Recht behalten. Zumindest was die B-Seite angeht."},{"height":"5"},{"name":"Plattenspieler","description":"JVC QL F-61  |  2008 erhalten","image":"Bachelor_010463.jpg","story":"Der erste Plattenspieler, den ich von einem guten Freund geschenkt bekommen habe. Uns verbindet ein ziemlich übereinstimmender Musikgeschmack – und dieser Plattenspieler.","width":"5","height":"5"},{"name":"Globus","description":"Starlight Globus  |  2014 gekauft","image":"01-globus.gif","story":"Hatte einer Freundin auf einem Flohmarkt erzählt, dass ich schon lange einen Globus mit schwarzen Wasserflächen suche. Darauf zeigt sie geradeaus: „So wie der da hinten?“ Für ein Schnäppchen von 8€ bekommen.","width":"9","height":"9"},{"name":"Zitruspresse","description":"Sitaku Zitruspresse  |  2017 gekauft","image":"0760.jpg","story":"Bei Manufactum entdeckt. Ich mag die simple Form von alltäglichen Gebrauchsgegenständen wie diesem. Macht den Gebrauch zum Vergnügen.","width":"3","height":"3"},{"width":"6"},{"width":"3","height":"9"},{"name":"Schuhe","description":"Vans Authentics Ultra Cush  |  2014 gekauft","image":"Bachelor_010541.jpg","story":"Werden seit 2014 fast jeden Tag getragen, auch im Winter. Bei Regen nerven die Löcher in den Sohlen. So bequem wie ein zweites Paar Socken.","width":"3","height":"3"},{"name":"Rennrad","description":"Colnago Sport  |  2012 gekauft","image":"Bachelor_010569.jpg","story":"Den Rahmen hab ich von einem Freund günstig bekommen, der bereits um die 100 Räder gekauft, an ihnen geschraubt und sie wieder verkauft hat. Um den Rahmen herum wurde alles sorgfältig aus Einzelteilen zusammengesucht und Stück für Stück aufgebaut. Das Rad fahre ich nur bei Sonnenschein und geparkt wird in der Wohnung.","width":"9","height":"9"},{"width":"3","height":"16"},{"name":"Ohrensessel","description":"Samt Altrosa  |  2016 erhalten","image":"Bachelor_010555.jpg","story":"Auf der Suche nach einem gebrauchten Lesesessel fand ich diesen Ohrensessel über Kleinanzeigen in meinem Wohnort. Noch am selben Tag abgeholt. Er stand bis dato in einer riesigen, alten und eindrucksvollen Stadtvilla, die zu der Zeit ausgeräumt wurde. Ich erfuhr vom Vorbesitzer, dass die Villa einem Seifenhersteller gehörte, dessen Firma mit Schwarzkopf fusionierte.","width":"9","height":"9"},{"name":"Becher","description":"Steingut  |  2015 gebraucht gekauft","image":"0763.jpg","story":"Daraus trinke ich am Wochenende morgens Kaffee mit meiner Freundin. Haben genau 2 Stück davon und benutzen sie nur am Wochenende.","width":"3","height":"3"},{"name":"E-Gitarre","description":"Fender Stratocaster Jimi Hendrix Signature  |  2001 gekauft","image":"Bachelor_010427.jpg","story":"Der erste Gegenstand, den ich wirklich haben wollte, worauf ich mehrere Jahre gespart habe. Da hängt viel Leidenschaft dran. Es musste ein Jimi Hendrix Signature Model sein. Hendrix habe ich zu der Zeit fast ausschließlich gehört.","width":"9","height":"9"},{"name":"Lautsprecher","description":"Canton Ergo RC-L  |  2014 gebraucht gekauft","image":"Bachelor_010575.jpg","story":"Ein langersehnter Wunsch. Per Inserat als Schnäppchen erstanden – in der Nähe meines Heimatortes. Persönlich abgeholt, innerhalb eines Tagestrips mit einem guten Freund, verknüpft mit einem Besuch bei meinen Eltern. Einer der besten Käufe jemals.","width":"9","height":"9"},{"width":"3","height":"9"},{"name":"Sofa","description":"mit Ausziehfunktion  |  2017 gebraucht gekauft","image":"DSC_2645.jpg","story":"Das Sofa habe ich für 1€ bei ebay ersteigert und in einer schöner Gegend in Stuttgart oben am Berg abgeholt. War nur etwas kalt auf der Rückfahrt, da es im Januar war und das Sofa nicht ganz ins Auto passte.","width":"9","height":"9"},{"name":"Armbanduhr","description":"Nixon Rotolog  |  2008 gekauft","image":"Bachelor_010517.jpg","story":"Bei einem Städtetrip in New York mit einem Freund gekauft. Erinnerungsstück. War das letzte Modell in schwarz, wie gewollt.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"name":"Pflanzen","story":"In fast allen Ecken der Wohnung sind Pflanzen zu finden, weil die Wohnung dadurch lebendiger und gleichzeitig gemütlicher wird.","position":"right","image":"pflanzen.jpg","type":"collection","width":"20","height":"6"},{"name":"HiFi Verstärker","description":"Denon AVC-A 11SR  |  2010 gebraucht gekauft","image":"amp.png","story":"Der erste Verstärker, bei dem ich einen deutlichen Unterschied zum Vorgänger hören konnte. Damit habe ich schon unzählige Stunden mit guter Musik erlebt. Mittlerweile wegen Transportschaden in Reparatur, aufgrund dessen die beauftragte Firma keinen Ersatz leistet.","width":"3","height":"3"},{"name":"Hängematte","description":"La Siesta  |  2012 gekauft","image":"IMG_3395.jpg","story":"6 Wochen recherchiert, bis ich eine passende Hängematte gefunden hatte. Hängt jetzt zwischen einem Kirsch- und einem Apfelbaum in meinem Garten. Mein Feierabend im Sommer.","width":"9","height":"9"},{"name":"Schallplatte","description":"lypurá: á  |  2016 erhalten","image":"Bachelor_010289.jpg","story":"Die Bandmitglieder sind 3 sehr gute Freunde von mir. Ich durfte dieses Cover gestalten. Ist deren erstes Album, das unter Vertrag veröffentlicht wurde. Ich habe es während meines Auslandsemesters in Kopenhagen gestaltet. Bin zur Releaseparty des Albums von Kopenhagen angereist – was sich gelohnt hat.","width":"5","height":"5"},{"width":"7","height":"5"},{"name":"Klavier","description":"Ed. Seiler Liegnitz  |  2012 gebraucht gekauft","image":"Bachelor_010609.gif","story":"Durch ein Missverständnis zwei Speditionen für den Transport beauftragt. Beim Stimmen sehr eigensinnig. Gewicht: 400kg. Der Umzug ins 3. OG eines Altbaus gestaltete sich schwierig bis fast unmöglich. Einer der 7 Schlepper hat sich fast den Kopf eingeklemmt. Glücklicherweise steht es jetzt da. Wird dementsprechend geschätzt.","width":"9","height":"9"},{"width":"3","height":"10"},{"name":"Butterdose","description":"Authentics - Smart Butterdose Groß  |  2010 erhalten","image":"0759.jpg","story":"Im Museumshop vom Vitra Museum entdeckt aber leider nicht gemerkt wie der Hersteller heißt. Beim Essen der Familie erzählt. Die Mutter meiner Freundin war aufmerksam und hat mir die Dose zu Weihnachten geschenkt. Sie hat einfach im Museumshop angerufen und die bestellt.","width":"3","height":"3"},{"name":"8mm-Kamera","description":"Bolex Paillard B8  |  2012 gebraucht gekauft","image":"Bachelor_010660.jpg","story":"Auf dem Flohmarkt entdeckt. Schon öfters im Internet drüber gestolpert, wird dort meist teuer gehandelt und auf dem Flohmarkt für 40€ gekauft aber noch nie ausprobiert und ist seither nur ein Vergnügen für die Augen.","width":"9","height":"9","items":[{"name":"8mm-Kamera","image":"Bachelor_010661.jpg"},{"name":"8mm-Kamera","image":"Bachelor_010662.jpg"}]},{"width":"3","height":"16"},{"name":"Schallplatte","description":"Architects: Lost Forever Lost Together  |  2015 gekauft","image":"Bachelor_010231.jpg","story":"Der erste Song dieses Albums wurde mir von einem guten Freund vorgespielt, was mich völlig umgehauen hat. Kein Album hat mich bisher so berührt wie das. Meine schönsten Konzerterlebnisse basieren darauf. Entsprechend hängen damit viele Geschichten und wunderbare Momente zusammen, so dass ich das Logo der Band mittlerweile als Tätowierung trage.","width":"9","height":"9"},{"width":"3","height":"9"},{"name":"Zahnbürste","description":"Muji Zahnbürste grün  |  2015 gekauft","image":"Bachelor_010656.jpg","story":"In Berlin in einem Laden von Muji entdeckt. Begeistert hat mich die simple Form, die viele Alltagsgegenstände oft nicht haben.","width":"9","height":"9"},{"name":"Schneidetisch","description":"Ideal 1110  |  2014 erhalten","image":"Bachelor_010800.jpg","story":"Bei einer Werkstattauflösung entdeckt und gekauft. Die Messer habe ich neu schleifen lassen und damit war der Tisch so gut wie neu – steht jetzt in meinem Zimmer.","width":"9","height":"9","items":[{"name":"Schneidetisch","image":"Bachelor_010809.jpg"}]},{"name":"Wanduhr","description":"Fisura  |  2016 gekauft","image":"Bachelor_010796.jpg","story":"Wurde mit einem Defekt geliefert. War mir dann zu nervig, das Ding zurückzuschicken und zu reklamieren. Mal eben selbst repariert.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"width":"7","height":"5"},{"name":"Platten","story":"Jedes Album, das ich gerne und oft höre, kaufe ich möglichst auf Platte. Ein Album am Stück zu hören geht sonst so sehr verloren. Das wäre schade.","position":"left","image":"platten.jpg","type":"collection","width":"20","height":"5"},{"name":"Bandshirt","description":"Mutiny on the Bounty  |  2013 gekauft","image":"Bachelor_010473.jpg","story":"Morgens nach einer Party ungeduscht direkt zur Autovermietung, um einen Mietwagen abzuholen. Zu Hause erst bemerkt, dass die Rückseite des Shirts voller Rotweinflecken von der Party war.","width":"3","height":"3"},{"name":"Rollladengurtblende","description":"Messing  |  2017 gekauft","image":"DSC_2655.jpg","story":"Die alte vergilbte Kunststoffblende wurde durch diese Messing-Blende ersetzt. Details machen so einen wahnsinnigen Unterschied.","width":"9","height":"9"},{"name":"Schallplatte","description":"Architects: All Our Gods Have Abandoned Us  |  2016 gekauft","image":"Bachelor_010223.jpg","story":"Müsste ich ein Lieblingsalbum nennen, wäre es das. Es ist die Musik, die ich immer gesucht habe. Vielleicht das erste Album, das ich noch nicht geschafft habe, totzuhören. ","width":"5","height":"5"},{"width":"7","height":"5"},{"name":"Konfetti","description":"Papier  |  2009 erhalten","image":"Bachelor_010524.jpg","story":"Ein Konfetti in Form eines Schmetterlings. Teil eines Konfettiregens auf einem wahnsinns Coldplay-Konzert, das ich mit meiner Freundin 2009 in München besuchte.","width":"9","height":"9"},{"width":"3","height":"10"},{"name":"iPod","description":"Apple ipod Video 30gb  |  2005 gekauft","image":"Bachelor_010537.jpg","story":"Musik zu hören war mir schon immer wichtig. Hat eine neue Dimension bekommen, als ich meine komplette Musiksammlung auf einmal überall mit hinnehmen konnte.","width":"3","height":"3"},{"name":"Super 8-Kamera","description":"gaf 738  |  2008 gebraucht gekauft","image":"Bachelor_010529.jpg","story":"Bei einem Trip nach New York im Jahr 2009 mit der Super 8-Kamera mehrere Szenen gefilmt und nie entwickelt. Der Film ist seither immer noch in der Kamera.","width":"9","height":"9"},{"width":"3","height":"17"},{"name":"Gemüsemesser","description":"Robert Herder Carbon Solingen  |  2013 erhalten","image":"Bachelor_010525.jpg","story":"Ein Geschenk meiner Mutter. Wurde zum Lieblingsmesser. Schon 2 Mal selbst verschenkt. Vor kurzem jemanden kennengelernt, der das gleiche Modell hat und es sich sogar tätowieren ließ.","width":"3","height":"3"},{"name":"Kuckucksuhr","description":"Unbekanntes Fabrikat  |  2012 erhalten","image":"DSC_2590.jpg","story":"Im Elternhaus meiner Freundin hängt eine winzige, aus Holz geschnitzte Kuckucksuhr, die mir sehr gefällt. Woraufhin meine Freundin mir diese Kuckucksuhr schenkte. Ein Freund hat nun schon öfters eine Sprachnachricht des stündlichen Kuckucksgeräusches von mir bekommen, was mit den Woodies und deren Fichtllied zu tun hat.","width":"9","height":"9"},{"width":"3","height":"15"},{"name":"Kachel","description":"Keramik  |  2017 hergestellt","image":"Bachelor_010523.jpg","story":"Hergestellt in einem Kachelkurs auf der Studienexkursion in Porto (Portugal), wo fast alle Hausfassaden mit diesem traditionellen Baustoff verziert sind. Ein Erinnerungsstück an diese schöne Reise. Wird vielleicht hinter dem Küchenherd Teil einer gefliesten Wand.","width":"9","height":"9"},{"name":"Fahrrad","description":"Triumph Barando  |  2017 erhalten","image":"Bachelor_010814.jpg","story":"Das Fahrrad meines Großvaters, der aus Altersgründen nicht mehr damit fährt. Von den Großeltern über Jahrzehnte im Keller aufbewahrt und immer gut gepflegt. Als ich es bekam, sah es aus wie neu. Neben meinen Rennrädern eine gemütliche Abwechslung. Und endlich kein nasser Rücken mehr bei Regen.","width":"9","height":"9"},{"name":"Bambus","description":"Phyllostachys  |  2014 erhalten","image":"bambus.gif","story":"Aus dem Garten eines Uni-Professors ausgegraben. War zu verschenken, musste 'nur' selbst ausgegraben werden. Hatte eine Höhe von 6m und mit 6 Leuten ausgehoben. Mit dem Autoanhänger in meinen Garten transportiert.","width":"9","height":"9","items":[{"name":"Bambus","image":"IMG_5463.jpg"},{"name":"Bambus","image":"IMG_3754.jpg"},{"name":"Bambus","image":"IMG_3767.jpg"},{"name":"Bambus","image":"IMG_3802.jpg"}]},{"name":"Gießkanne","description":"Haws Watering Cans Kupfer  |  2017 erhalten","image":"Bachelor_010699.jpg","story":"Geburtstagsgeschenk meiner Freundin, weil wir Zuhause keine Gießkanne hatten und immer mit einer Wasserflasche herumgewandert sind zum Gießen.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"name":"Vasen","story":"Ich sammle kleine Vasen und Gefäße. Die schenken Räumen eine gewisse Ästhetik, ob sie etwas beinhalten oder nicht.","position":"right","image":"vasen.jpg","type":"collection","width":"20","height":"5"},{"name":"Schere","description":"Dovo 51  |  2009 erhalten","image":"Bachelor_010739.jpg","story":"Mit jeder anderen Schere fühlt es sich so unbeschreiblich schlecht an, sich die Nägel zu schneiden. Hatte schonmal nach dem gleichen Model geschaut und eine ähnliche Schere im selben Laden aus dem diese stammt gekauft. War aber nicht gut.","width":"3","height":"3"},{"name":"Kleiderschrank","description":"Holz mit Bierlasur  |  2011 gebraucht gekauft","image":"DSC_2678.jpg","story":"2011 spontan beim Frühstück in einer ebay-Auktion ersteigert. Konnte in der Nachbarschaft abgeholt werden – nur 2 Straßen von meiner Wohnung entfernt. Ich mag die Verzierungen an der Kante der Regalböden. Hat Seltenheitswert.","width":"9","height":"9","items":[{"name":"Kleiderschrank","image":"DSC_2677.jpg"}]},{"name":"Sessel","description":"Knoll Antimott  |  2016 gebraucht gekauft","image":"Bachelor_010605.jpg","story":"Über Kleinanzeigen sehr günstig dran gekommen (65€) und sitze gerne darauf. Der Stoff hat so eine intensive Farbe und ist wie neu.","width":"5","height":"5"},{"width":"7","height":"5"},{"name":"Tasse","description":"iittala teema  |  2013 gekauft","image":"Bachelor_010658.jpg","story":"Als meine Freundin und ich zusammenzogen, konnten wir uns auf keine Tassen einigen. Sie wollte bunt, ich schlicht. Daher gab’s zunächst Kaffee und Tee aus Gläsern. Heute sammeln wir Tassen nach dem Muster: schlicht in bunt, pro Tasse eine Farbe.","width":"9","height":"9","items":[{"name":"Tasse","image":"Bachelor_010658a.jpg"}]},{"width":"3","height":"10"},{"name":"Fernglas","description":"Unbekanntes Fabrikat  |  1997 erhalten","image":"Bachelor_010734.jpg","story":"Ein Geschenk meiner Großeltern. In meiner Kindheit beobachteten wir damit Vögel. Heute steht es als Erinnerungsstück in meinem Zimmer. Einmal habe ich damit vom 3. Obergeschoss aus nachgesehen, ob ein Strafzettel hinter dem Scheibenwischer klemmt, als ich vor dem Haus falsch geparkt hatte.","width":"3","height":"3"},{"name":"Kuriertasche","description":"Mission Workshop The Shed  |  2011 gebraucht gekauft","image":"Bachelor_010405.jpg","story":"Diese Tasche benutze ich seit 2011 fast täglich. Selbst ein Klappstuhl passt hinein. Fassungsvermögen: 32 Liter – warum andere auch gerne mal schmunzeln und fragen was ich denn alles dabei hätte.","width":"9","height":"9"},{"width":"3","height":"17"},{"name":"Stofftier","description":"Steiff Linda Lamm  |  2017 erhalten","image":"Bachelor_010659.jpg","story":"Ein Geschenk an eine Freundin, die kürzlich Mutter wurde. Ich fand das Tierchen recht putzig und bekam es daraufhin selbst von meiner Freundin.","width":"3","height":"3"},{"name":"Küchenradio","description":"Tivoli Audio Model One  |  2011 gebraucht gekauft","image":"DSC_2672.jpg","story":"Ein Geschenk, dass ich meiner Freundin vor einigen Jahren machte. Wir hören beide jeden morgen damit während des Frühstücks – es läuft Deutschlandfunk oder eigene Musik über Aux.","width":"9","height":"9"},{"width":"3","height":"15"},{"name":"Leinwand","description":"68x90cm selbstgebauter Rahmen mit Leinwand  |  2010 gebaut","image":"Bachelor_010403.jpg","story":"Eigene Handarbeit bis hin zum Rahmen. Das Motiv stammt von einer meiner Lieblingsplatten (Moderat) und wurde in stundenlanger Arbeit mit Tusche aufgebracht. Die kleinen braunen Flecken unten rechts entstanden während einer Party als eine Red Bull-Dose explodierte.","width":"9","height":"9"},{"name":"Souvenir","description":"Lava  |  2011","image":"Bachelor_010694.jpg","story":"Schwarzer Sand vom Strand aus Island. Erinnerungsstück an eine besondere Reise. Besuchte einen Freund, der sein Auslandssemester dort verbrachte.","width":"9","height":"9"},{"name":"Gartenschlauch","description":"Continental Goldschlange  |  2015 gebraucht gekauft","image":"schlauch.gif","story":"Mein alter Schlauch knickte beim Gießen immer ab. Eine lange Recherche folgte, bevor ich mir diesen Schlauch gebraucht gekauft habe. Er sollte effizient und langlebig sein. Das ist er bis jetzt und hoffentlich noch lange… Und ich mag das Gießen, das hat was meditatives.","width":"9","height":"9"},{"name":"T-Shirt","description":"Selbst bedruckt  |  2013 erhalten","image":"Bachelor_010467.jpg","story":"Aufgrund eines anderen T-Shirts mit Hippiepärchen-Aufdruck, wurde ich wiederholt gefragt, ob das meine Eltern seien. Sogar Fremde auf der Straße haben mich das gefragt. Das fand ein Freund sehr amüsant und er ließ mir dieses Shirt bedrucken – mit Urlaubsfoto meiner Familie.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"name":"Holzboxen","story":"In alten Archivkisten bewahre ich Sachen wie Klebebänder, Farben und Lacke, Kabel, Festplatten und Fernbedienungen auf.","position":"right","image":"Bachelor_010559.jpg","type":"collection","width":"20","height":"5"},{"name":"Plattenspieler","description":"Pro-Ject Debut iii  |  2011 gebraucht gekauft","image":"Bachelor_010217.jpg","story":"Der zweite Plattenspieler, den ich mir gebraucht gekauft habe. Ich mag ihn, weil er so einfach zu bedienen ist. Er hat nur einen Ein-/Aus-Schalter.","width":"3","height":"3"},{"name":"Metalldose","description":"Asperg Flickzeug Metalldose  |  2012 gebraucht gekauft","image":"Bachelor_010690.jpg","story":"Auf dem Flohmarkt gekauft, weil ich ein Behälter für mein Fahrradflickzeug gesucht und tatsächlich diesen gefunden hatte.","width":"9","height":"9"},{"name":"Schallplatte","description":"Funeral For A Friend: Hours  |  2008 gekauft","image":"Bachelor_010247.jpg","story":"Ein Album aus meiner Jugend. Darauf ist eine der schönsten Balladen, die ich kenne – History. Verbindet mich mit meiner alten Band, mit der zusammen ich auch auf deren letzten Tour vor der Auflösung war.","width":"5","height":"5"},{"width":"7","height":"5"},{"name":"Kommode","description":"Holz lassiert  |  2011 erhalten","image":"Bachelor_010601.jpg","story":"Die Kommode stand lange im Keller meiner Familie als Lager für Lack- und Farbdosen. Wurde restauriert und dient heute als Aufbewahrung für meine Filmsammlung.","width":"9","height":"9"},{"width":"3","height":"10"},{"name":"Taschenrechner","description":"Braun Typ 4777  |  1999 erhalten","image":"Bachelor_010521.jpg","story":"Von den Eltern geschenkt bekommen, wir hatten davon glaub ich 3 Stück zuhause.","width":"3","height":"3"},{"name":"Klappzahlenwecker","description":"Braun Typ 4924  |  2010 gebraucht gekauft","image":"braun_wecker.gif","story":"Bei ebay ersteigert für stolze 60€ und er geht ein bisschen zu langsam. Sollte ich mal reparieren lassen, wäre sonst schade um das schöne Stück.","width":"9","height":"9"},{"width":"3","height":"17"},{"name":"Farbdose","description":"Farrow&Ball Parma Gray No. 27  |  2017 gekauft","image":"Bachelor_010664.jpg","story":"Bevor ich die Wände eines Zimmers streiche, hole ich mir aus der Farbkarte von Farrow&Ball Inspiration oder lasse die Farben nachmischen. Das Original ist unbezahlbar. Für das nächste Projekt Schlafzimmer steht ein Probefarbtopf bereit.","width":"3","height":"3"},{"name":"Malerei","description":"Acryl auf Leinwand  |  2016 erhalten","image":"Bachelor_010157.jpg","story":"Von einem befreundeten Künstler, der mit einer Palmenserie andere Künstler und deren inflationäre Verwendung des Palmenmotivs parodiert. Fand ich gut – darauf dieses personalisierte Exemplar geschenkt bekommen.","width":"9","height":"9"},{"width":"3","height":"15"},{"name":"Schreibtischstuhl","description":"Vitra Meda  |  2009 erhalten","image":"Bachelor_010595.jpg","story":"Auf dem saß ich in der Agentur in der ich meine Ausbildung machte. Fand den immer super. Ein Geschenk meiner Mutter zum Einzug in die erste eigene Wohnung.","width":"9","height":"9"},{"name":"Hocker","description":"Holz und Stahl  |  2014 gebraucht gekauft","image":"Bachelor_010589.jpg","story":"Beim Familienbesuch in Konstanz auf dem Flohmarkt 3 Stück davon gekauft. Ein Exemplar davon hat eine Freundin bekommen. Die Hocker haben sich im Alltag als außerordentlich praktisch erwiesen. Dienen als Beistelltisch, Tritthocker, Sitzgelegenheit und Ablagefläche.","width":"9","height":"9"},{"name":"Lichtschalter","description":"Berker 1930  |  2012–2016 gebraucht/neu gekauft","image":"DSC_2687.jpg","story":"Ich wechsle bei mir zuhause alle Lichtschalter und Steckdosen aus, weil diese viel zur Gestaltung und Wirkung des Wohnraums beitragen. Darüber schmunzeln andere gerne mal, aber ich freu mich tatsächlich jedes Mal, wenn ich sie benutze.","width":"9","height":"9","items":[{"name":"Lichtschalter","image":"DSC_2700.jpg"},{"name":"Lichtschalter","image":"DSC_2684.jpg"},{"name":"Lichtschalter","image":"DSC_2692.jpg"},{"name":"Lichtschalter","image":"DSC_2694.jpg"},{"name":"Lichtschalter","image":"DSC_2704.jpg"}]},{"name":"Tasche","description":"The Tidal Sleep  |  2015 erhalten","image":"Bachelor_010353.jpg","story":"Die Tasche ist Merchandise von einer Band mit denen ich mir früher den Proberaum geteilt habe und die heute sehr erfolgreich ist. Die Tasche war ein Geschenk von meiner Freundin, weil ich immer ihre Tasche benutzt habe. Sie hat die gleiche. Hat dann dem Schlagzeuger geschrieben der in der ebenfalls in Karlsruhe wohnt und bei ihm abgeholt.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"name":"Magazine","story":"Ich kaufe mir schon immer gerne Magazine. Themen: Gestaltung, HiFi, Interior, Wirtschaft, Bonsai, Architektur.","position":"right","image":"magazine.jpg","type":"collection","width":"20","height":"5"},{"name":"Spezi","description":"Oettinger Cola-Mix  |  seit 1998 im Verbrauch","image":"0761.jpg","story":"Mein absolutes Lieblingsgetränk, das ich jeden Tag trinke. Andere machen gerne Späße über meinen hohen Spezikonsum. Immer ein Kasten zuhause.","width":"3","height":"3"},{"name":"Hängeaufbewahrung","description":"IKEA Kroken  |  2017 gebraucht gekauft","image":"DSC_2695.jpg","story":"Entdeckt in einem hochpreisigen Einrichtungshaus in Kopenhagen. Nicht auf deren Website gefunden, nachgefragt und erfahren, es sei von IKEA. Dort war es nicht mehr im Programm. Während längerer Recherche bei Kleinanzeigen gefunden.","width":"9","height":"9"},{"name":"Schallplatte","description":"Element Of Crime: Damals hinterm Mond  |  2016 gekauft","image":"Bachelor_010259.jpg","story":"Von einem Freund gezeigt bekommen, den ich einmal im Jahr an Weihnachten treffe. Zu der Zeit war ein totales Schneechaos und er meinte: „Die Scheibe passt genau zu dem Wetter da draußen.“ Erinnert mich heute noch jedes Mal daran, wenn ich die Platte auflege.","width":"5","height":"5"},{"width":"7","height":"5"},{"name":"Kaktus","description":"2013 erhalten","image":"Bachelor_010689.jpg","story":"Von einer Freundin geschenkt bekommen als ich in eine andere Stadt zog zum Studium – damit mein Schreibtisch nicht so leer ist.","width":"9","height":"9"},{"width":"3","height":"10"},{"name":"Tagebuch","description":"Buch mit Filzhülle  |  2013 erhalten","image":"0767.jpg","story":"Von den Eltern geschenkt bekommen. Das Tagebuch über die Erlebnisse in meinen ersten Lebensjahren.","width":"3","height":"3"},{"name":"Wecker","description":"Kienzle  |  1995 erhalten","image":"Bachelor_010686.jpg","story":"Von meiner Schwester bekommen als ich klein war. Auseinander gebaut und die Minutenskala schwarz angemalt, weil sie selbstleuchtend ist, das war mir nachts zu hell.","width":"9","height":"9"},{"width":"3","height":"17"},{"name":"Feuerzeug","description":"Wanson  |  2003 gebraucht gekauft","image":"Bachelor_010693.jpg","story":"Als ich eine Zeitlang Objekte aus den 50ern schön fand gekauft. Liegt zuhause aber eher unbenutzt herum, freu mich aber darüber wenn ich es in der Kiste finde.","width":"3","height":"3"},{"name":"Stuhl","description":"ilmari tapiovaara stuhl  |  2012 gefunden","image":"Bachelor_010577.jpg","story":"Ein Designklassiker. Einzelne Stücke zu 2 verschiedenen Zeitpunkten im Sperrmüll gefunden. Besitze mittlerweile 5 Stück davon. Den Rest gebraucht auf Flohmarkt und ebay gekauft.","width":"9","height":"9"},{"width":"3","height":"15"},{"name":"Kette mit Anhhänger","description":"Metall  |  2012 gekauft","image":"0774.jpg","story":"In Neuseeland (Nelson) auf einem Markt gekauft als ich mit der Mutter eines Arbeitskollegen der von dort kommt über den Markt ging. Der Verkäufer hieß tatsächlich Jewel mit Vornamen.","width":"9","height":"9"},{"name":"Keramikhaus","description":"Family Tree Shop  |  2015 erhalten","image":"DSC_2666.jpg","story":"Das kleine Haus war ein Geschenk meiner Freundin als wir unsere dritte gemeinsame Wohnung bezogen haben.","width":"9","height":"9"},{"name":"Wählscheibentelefon","description":"Fr. Reiner W48  |  2016 gebraucht gekauft","image":"Bachelor_010716.jpg","story":"Das Telefon steht auf meinem Schreibtisch. Wird für längere Gespräche verwendet. Ist bequemer und griffiger. Als ich klein war, hatten meine Großeltern ein ähnliches Modell in Gebrauch.","width":"9","height":"9"},{"name":"Tennisschläger","description":"Dunlop  |  2012 gekauft","image":"Bachelor_010449.jpg","story":"Auf dem Flohmarkt gekauft, einfach nur weil er mir gefiel. Nie Tennis gespielt oder einen Bezug dazu.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"},{"name":"Notizbücher","story":"Notizbücher kaufe ich schneller als ich sie verbrauche. 3 sind ständig in Gebrauch: 1 kleines für unterwegs, 1 für Erlebnisse, 1 für Ideen und Arbeit.","position":"right","image":"notebooks.jpg","type":"collection","width":"20","height":"5"},{"name":"Schlüsselanhänger","description":"Lego Star Wars C3PO  |  2016 erhalten","image":"0775.jpg","story":"Ein Geschenk meines Vaters als er mich im Auslandsemester in Dänemark besuchte. Einen Legostore besucht, heimlich gekauft und mir später überreicht. Wir spielten gerne Lego zusammen als ich klein war. An regnerischen Sonntagen sahen wir zusammen Star Wars.","width":"3","height":"3"},{"name":"Hörgeräte","description":"Siemens Pure  |  2016 gekauft","image":"Bachelor_010810.jpg","story":"Durch zu laute Konzerte und Bandproben verursachte Schwerhörigkeit bedingte den Kauf von Hörgeräten. Ergebnis: eine deutliche Verbesserung der Lebensqualität.","width":"9","height":"9"},{"name":"Glühbirnenfassung","description":"Fassung mit Drehschalter aus Bakelit  |  2016 installiert","image":"DSC_2661.jpg","story":"Die Glühbirne mit Fassung liegt in der Speisekammer, in der es zuvor kein Licht gab. Ich wollte zunächst eine Fassung mit Zugschalter anbringen. Ohne Verwendungszweck war bis dato diese Fassung mit Drehschalter vom Flohmarkt. Funktioniert und ist auch schön.","width":"5","height":"5","items":[{"name":"Glühbirne mit Fassung","image":"DSC_2660.jpg"}]},{"width":"7","height":"5"},{"name":"Armbanduhr","description":"Citizen 21 Jewels  |  1998 erhalten","image":"Bachelor_010751.jpg","story":"Die Uhr war ein Geschenk meiner Mutter an meinen Vater. War bei den beiden mit auf Hochzeitsreise in Mexiko und hat mittlerweile ihr drittes Armband. Zwar keine Schönheit und läuft auch jeden Tag etwa 1 Minute zu schnell, aber ich häng dran wegen der Geschichte.","width":"9","height":"9"},{"width":"3","height":"10"},{"name":"Gitarrenverstärker","description":"Orange Micro Terror  |  2016 gekauft","image":"Bachelor_010665.jpg","story":"Ein Mikroverstärker den ich als Zweitverstärker verwende, um mit der Gitarre Stereoeffekte beim Musikmachen erzeugen zu können. Der ist so klein wie eine Lunchbox.","width":"3","height":"3"},{"name":"Schreibtischlampe","description":"Unbekanntes Fabrikat  |  2011 gebraucht gekauft","image":"08-lampe.jpg","story":"Auf dem Flohmarkt entdeckt für kleines Geld entdeckt und freue mich jeden Tag daran. Steht auf meinem Schreibtisch.","width":"9","height":"9"},{"width":"3","height":"17"},{"name":"Stativ","description":"Unbekanntes Fabrikat  |  2012 gebraucht gekauft","image":"Bachelor_010737.jpg","story":"Auf dem Flohmarkt gekauft und einem Arbeitskollegen gezeigt, der totaler Minimalist ist. Er so: „Und das legst du dir jetzt unters Sofa oder was?“ – am Ende wurde es das Regal.","width":"3","height":"3"},{"name":"Leinwand","description":"168x97cm, Papier & Holz  |  2012 gebaut","image":"Bachelor_010439.jpg","story":"Ein Bild meines Großvaters mit seinen Kameraden aus Jugendzeiten. Entdeckt beim Durchblättern eines alten Fotoalbums. Eingescannt und vergrößert ausgedruckt. Später einen Holzrahmen dafür gebaut. Mein Großvater ist der zweite von rechts mit der Zigarette im Mundwinkel. In der Klamotte sind die Jungs damals abends ausgegangen.","width":"9","height":"9"},{"width":"3","height":"15"},{"name":"Salz- und Pfefferstreuer","description":"Steingut  |  2015 erhalten","image":"Bachelor_010688.jpg","story":"Im Gegenzug fürs Ausleihen von Reiserucksack und -führer für Sri Lanka von einem Arbeitskollegen als Souvenir bekommen.","width":"9","height":"9"},{"name":"Schuhe","description":"Vans Old Skool  |  2017 gekauft","image":"Bachelor_010742.jpg","story":"Endlich mal neue Schuhe gekauft, die bei längerem Tragen aber sehr unbequem wurden. Zwei Freunde die die Schuhe auch haben meinten: „Ja war bei mir auch so, da musst du durch.“","width":"9","height":"9"},{"name":"Spiegelreflexkamera","description":"Praktica Super TL3  |  2002 erhalten","image":"Bachelor_010663.jpg","story":"Damit das Fotografieren gelernt. Die alte analoge Spiegelreflexkamera meines Vaters. Ich erinnere mich noch an unsere Urlaube als ich klein war. Mein Vater hat immer minutenlang an der Kamera feinjustiert, bis ein Foto gemacht war.","width":"9","height":"9"},{"name":"Bandshirt","description":"Architects  |  2016 gekauft","image":"Bachelor_010477.jpg","story":"Ein Shirt meiner Lieblingsband deren Gestaltung ich sehr beachtlich finde. Besonders für eine Band aus dem Genre Metal, in dem es mit der Ästhetik meistens nicht so weit her ist.","width":"3","height":"3"},{"width":"2","height":"4"},{"width":"2","height":"9"}]}

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01-globus.dec325b.gif";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/06-huette.b11d325.jpg";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0754.9e42290.jpg";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0755.3704ad4.jpg";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0756.cc0a057.jpg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0757.59f7108.jpg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0758.527ee22.jpg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0759.c1ca400.jpg";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0760.8222471.jpg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0761.437c3a2.jpg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0762.60ec6a2.jpg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0763.fc21f6a.jpg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0764.7409374.jpg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0765.eb8dcdb.jpg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0767.830e85b.jpg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0768.610391c.jpg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0769.6712e45.jpg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0770.0308f2c.jpg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0771.07305c5.jpg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0772.792eb45.jpg";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0773.c99a75c.jpg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0774.1c23d83.jpg";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0775.7581e88.jpg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0776.b650c65.jpg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/08-lampe.5eb63f3.jpg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/30er-lampe.9337a18.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010157.a8b68d9.jpg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010159.b571ed5.jpg";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010177.b4f2dd5.jpg";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010193.a708616.jpg";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010217.cf510d9.jpg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010223.0854160.jpg";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010231.ad6d03a.jpg";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010233.e12a74f.jpg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010239.29260b3.jpg";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010241.869bb1c.jpg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010243.0d652b2.jpg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010247.7f4f3d6.jpg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010253.02b5e38.jpg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010257.1f780fc.jpg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010259.882f63d.jpg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010261.f7467a3.jpg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010265.2dc3172.jpg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010271.e2f9021.jpg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010275.1a87397.jpg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010277.4535a44.jpg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010279.a299d69.jpg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010285.aadb723.jpg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010287.58db133.jpg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010289.1a49ddd.jpg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010293.a1cf5b2.jpg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010295.599dbc0.jpg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010299.27f5327.jpg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010301.13e6d3f.jpg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010303.c9f0ddc.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010309.a6acfb9.jpg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010311.7ab7c66.jpg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010321.42ba4ed.jpg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010327.a841859.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010335.35b82c6.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010341.6627081.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010347.4baeb0a.jpg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010349.77731de.jpg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010353.3e6ae7a.jpg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010357.96f1cd0.jpg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010361.933a674.jpg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010369.673547a.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010397.0b3a587.jpg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010401.b9eb27b.jpg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010403.77ab193.jpg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010405.8e2ff85.jpg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010413.2f33722.jpg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010427.83fd240.jpg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010429.7071779.jpg";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010439.604d35c.jpg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010447.6d81b1c.jpg";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010449.05273cc.jpg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010453.2ef7bb5.jpg";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010463.8ae7c3a.jpg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010467.5744791.jpg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010471.7094f60.jpg";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010473.18db110.jpg";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010477.9d2d0b1.jpg";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010481.a18465e.jpg";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010517.4baae23.jpg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010519.3a8705f.jpg";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010521.a032f57.jpg";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010523.f1aeaa9.jpg";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010524.2024dfc.jpg";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010525.9d588ea.jpg";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010529.27864b9.jpg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010531.80af8b9.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010533.6048fdb.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010537.738f105.jpg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010541.8e61487.jpg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010547.a84482a.jpg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010551.c11a56f.jpg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010555.87f4b17.jpg";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010559.7e90edb.jpg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010569.86a7156.jpg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010575.dadbe76.jpg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010577.195711f.jpg";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010583.7210692.jpg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010587.c370ea6.jpg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010589.b0dc699.jpg";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010595.c982b04.jpg";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010601.6d986cc.jpg";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010605.446fe15.jpg";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010609.34e9546.gif";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010653.0fd59a9.jpg";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010656.72282c9.jpg";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010658.3792581.jpg";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010658a.682687f.jpg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010659.eb92d57.jpg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010660.438d1a4.jpg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010661.2ee2601.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010662.2fece5b.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010663.a97b75d.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010664.25da33a.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010665.0488789.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010685.89e8d22.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010686.fa50ff9.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010687.664ab19.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010688.8fd691d.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010689.3f3f398.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010690.021d0b8.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010691.dad135c.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010692.dcd8914.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010693.d326715.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010694.fc4307a.jpg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010695.599e202.jpg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010696.1695ff0.jpg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010697.ad93371.jpg";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010698.83fa444.jpg";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010699.558ff0a.jpg";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010700.d63ea79.jpg";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010705.5d25231.jpg";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010706.85a17df.jpg";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010713.5d0a2b0.jpg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010714.af35488.jpg";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010715.ad4dfb0.jpg";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010716.79da124.jpg";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010728.356ffa6.jpg";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010732.50b9b6d.jpg";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010734.486a8cd.jpg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010735.84d8ceb.jpg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010737.d54c72b.jpg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010738.8381d7b.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010739.98b1e9d.jpg";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010742.fa9de1e.jpg";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010743.342cdec.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010751.ce1e4e8.jpg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010753.97fcedd.jpg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010779.09f7631.jpg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010783.1e55ab4.jpg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010786.9f01b12.jpg";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010791.3efd851.jpg";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010792.8469314.jpg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010794.2e8fdc2.jpg";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010795.7759f3c.jpg";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010796.22d7f01.jpg";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010800.b2439ad.jpg";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010809.4e007a5.jpg";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010810.b599322.jpg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010812.24d5de4.jpg";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010814.1f00823.jpg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010825.3e35665.jpg";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010827.2a76ac0.jpg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010829.d375fb1.jpg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010830.343a944.jpg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010853.5913fc8.jpg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010854.51610d7.jpg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010855.53cc533.jpg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bachelor_010856.b66b8ff.jpg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2590.1ff503b.jpg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2645.b753f7e.jpg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2655.0063bab.jpg";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2660.d4fc827.jpg";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2661.2f84b8c.jpg";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2666.ccb6fff.jpg";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2672.f016e71.jpg";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2677.54f2a12.jpg";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2678.12999bc.jpg";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2684.ab62fa5.jpg";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2687.ecf391a.jpg";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2692.7c79cee.jpg";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2694.737d48d.jpg";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2695.bf9b1af.jpg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2700.0eefaad.jpg";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2704.96c14f9.jpg";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DSC_2705.98ad9dd.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IMG_3395.9ceccc8.jpg";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IMG_3754.0049d90.jpg";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IMG_3767.cceb766.jpg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IMG_3802.7d0ae47.jpg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IMG_5463.e41ef49.jpg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/akkuschrauber.9cdc31b.png";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amp.1334005.png";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amp2.b394d8a.png";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bambus.dbd6302.gif";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/braun_wecker.f6bdd51.gif";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/club-mate.66ec407.png";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earplugs.d93c777.png";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glaeser.0cb7766.jpg";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/goldwand.afd966d.jpg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/magazine.eeda413.jpg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nikon.6de5fb2.jpg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notebooks.6f7af05.jpg";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pflanzen.9d27d1d.jpg";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/platten.17390d3.jpg";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/portrait.dc25bcd.jpg";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/schlauch.dd0e75d.gif";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/taschenmesser.932c3d7.jpg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/usb-soundstick.8a2a146.jpg";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vasen.a377fd6.jpg";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(317),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6176d1dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'modal--instagram': _vm.isExternalImage(_vm.modalImage)
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [(!_vm.item.hideNavigation) ? _c('i', {
    staticClass: "modal__icon modal__icon--previous",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPrevious()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.item.hideNavigation) ? _c('i', {
    staticClass: "modal__icon modal__icon--next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showNext()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "modal__icon modal__icon--close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__image"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.imagePath(_vm.modalImage)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal__text"
  }, [_c('header', [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExternalImage(_vm.modalImage)),
      expression: "!isExternalImage(modalImage)"
    }]
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imagePath(_vm.item.profile)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  })]), _vm._v(" "), _c('article', [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExternalImage(_vm.modalImage)),
      expression: "!isExternalImage(modalImage)"
    }]
  }, [_vm._v("Story")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.story)
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExternalImage(_vm.modalImage)),
      expression: "isExternalImage(modalImage)"
    }],
    attrs: {
      "href": _vm.item.link
    }
  }, [_vm._v("Auf Instagram anzeigen »")])])])]), _vm._v(" "), (_vm.item.items) ? _c('ul', {
    staticClass: "modal__gallery"
  }, _vm._l((_vm.item.items), function(image, index) {
    return _c('li', {
      class: {
        'active': _vm.activeImage === index
      },
      on: {
        "click": function($event) {
          _vm.setActiveImage(image, index)
        }
      }
    }, [_c('figure', [_c('img', {
      attrs: {
        "src": _vm.imagePath(image.image)
      }
    })])])
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.elements), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "item": item,
        "index": index,
        "previousItem": _vm.previousItem,
        "nextItem": _vm.nextItem
      },
      on: {
        "active": _vm.active
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['item', _vm.itemWidth(_vm.item), _vm.itemHeight(_vm.item), _vm.isItemDisabled() ? 'is-disabled' : '']
  }, [(_vm.item.type === 'collection') ? _c('div', {
    class: ['item__note', 'item__note--' + _vm.item.position]
  }, [_c('span', [_vm._v(_vm._s(_vm.item.story))])]) : _vm._e(), _vm._v(" "), (_vm.item.image) ? _c('figure', {
    on: {
      "click": function($event) {
        _vm.showModal(_vm.index)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePath
    }
  })]) : _vm._e(), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "item": _vm.item
    },
    on: {
      "hide": function($event) {
        _vm.hideModal()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "grid wrapper animation animation--delayed"
  }, [_c('items', {
    staticClass: "masonry",
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _c('instagram')], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instagram"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "instahead"
  }, [_vm._v("Dinge und Geschichten von anderen")]), _vm._v(" "), _c('items', {
    staticClass: "instafeed grid wrapper",
    attrs: {
      "items": _vm.items
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('article', [_c('h4', [_vm._v("#liebdinge")]), _vm._v(" "), _c('i', {
    staticClass: "heart"
  }), _vm._v(" "), _c('h2', [_vm._v("Teile dein Liebding auf Instagram")])])])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "item": _vm.about
    },
    on: {
      "hide": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "site-navigation"
  }, [_c('ul', [_c('li', [_c('div', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--arrow-top"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Nach")]), _vm._v(" oben")])])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showModal(_vm.index)
      }
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--circle"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Über")]), _vm._v(" mich")])])]), _vm._v(" "), _c('li', [_c('jump', {
    attrs: {
      "target": ".instagram"
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('i', {
    staticClass: "icon icon--hash"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Dein")]), _vm._v(" "), _c('span', [_vm._v("Lieb")]), _vm._v(" ding")])])])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[40]);


// WEBPACK FOOTER //
// static/js/app.fd3f21d6a0ba897a40f6.js